/* global axios */
import ApiClient from './ApiClient';

class DataTransfersAPI extends ApiClient {
  constructor() {
    super('data_transfers', { accountScoped: true });
  }

  get({ direction, dataType, status, page = 1 } = {}) {
    return axios.get(this.url, {
      params: {
        direction,
        data_type: dataType,
        status,
        page,
      },
    });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // Previa em tabela do comeco do arquivo. `file` = 'source' | 'failed'; sem ele o servidor abre
  // o mesmo arquivo que o download entrega.
  preview(id, { file } = {}) {
    return axios.get(`${this.url}/${id}/preview`, { params: { file } });
  }

  // Cancela e desfaz o que a transferencia ja fez (#1551). Devolve o registro com o status novo
  // (`cancelling`, ou `cancelled` quando nao havia o que desfazer).
  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  // responseType 'blob' e obrigatorio: sem ele o axios interpreta o CSV como texto e a
  // acentuacao chega corrompida no arquivo salvo. `file` = 'succeeded' | 'failed'; sem ele o
  // servidor entrega o arquivo de sempre (resultado da exportacao, falhas da importacao).
  download(id, { file } = {}) {
    return axios.get(`${this.url}/${id}/download`, {
      params: { file },
      responseType: 'blob',
    });
  }
}

export default new DataTransfersAPI();
